import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import VueClipboard from "vue-clipboard2";

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
AOS.init();
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
